var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-embed-custom",style:('height:' + this. getHeight())},[_c('b-embed',{style:('height:' + this. getHeight()),attrs:{"type":"iframe","src":this.data,"allowfullscreen":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }